var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('email-manager',{attrs:{"configurations":_vm.email_configurations}}),_c('sms-manager',{ref:"sms"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }